import { Outlet } from 'react-router';
import TopNav from './TopNav';
import LiveTicker from './LiveTicker';
import Footer from './Footer';
import Grain from '../motion/Grain';
import { DEFAULT_TICKER_MESSAGE } from '../config/season';

export default function Layout({ tickerMessage = DEFAULT_TICKER_MESSAGE }) {
  return (
    <div className="min-h-screen bg-bg-base text-ink-primary">
      <Grain />
      <LiveTicker message={tickerMessage} />
      <TopNav />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
